<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderClientSlim :project="project" />
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h3>{{ $t('roofSidesShadowsState') }}</h3>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('roofSidesShadowsState') }}</div>
        <div>{{ $t(project.measurement.pitchedRoof.roofSidesShadowsState) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      v-if="project.measurement.pitchedRoof.roofSidesShadowsState !== 'NO'"
      :attachments="project.roofSidesShadowsAttachments"
      fieldName="roofSidesShadowsAttachments"
      fieldDescription="roofSidesShadowsAttachments_description"
      :maxImages="2"
    />

    <AttachmentsPrintGrid
      :attachments="project.roofSidesSketchAttachments"
      fieldName="roofSidesSketchAttachments"
      fieldDescription="roofSidesSketchAttachments_description"
      :maxImages="2"
    />

    <AttachmentsPrintGrid
      v-if="project.flatRoofOptionalAttachments || flatRoof.flatRoofNotes"
      :attachments="project.flatRoofOptionalAttachments"
      fieldName="optionalNotesAndAttachments"
      :maxImages="2"
    >
      <div class="two-column-grid">
        <div>{{ $t('optional_notes_description') }}</div>
        <div>{{ project.measurement.flatRoof.flatRoofNotes }}</div>
      </div>
    </AttachmentsPrintGrid>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderClientSlim from '@/components/Print/PrintHeaderClientSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';

import { range } from '@/helpers/math.js';

export default {
  components: {
    PrintPage,
    PrintHeaderClientSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: 1 },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {
    isFlatRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'FLAT_ROOF';
    },
    isPitchedRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'PITCHED_ROOF';
    },
  },
  methods: { range },
};
</script>
